import { SearchFilterProfessionalGenderType } from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-professional-gender.type';
import { SearchApiProfessionalGender } from '@/app/(main)/(pages)/_types/search-api-response.type';

const SEARCH_API_PROFESSIONAL_GENDER: Partial<
  Record<SearchFilterProfessionalGenderType, SearchApiProfessionalGender>
> = {
  [SearchFilterProfessionalGenderType.MALE]: 'MALE',
  [SearchFilterProfessionalGenderType.FEMALE]: 'FEMALE',
};

export function toSearchApiProfessionalGender(
  professionalGender?: SearchFilterProfessionalGenderType,
): SearchApiProfessionalGender | undefined {
  return professionalGender ? SEARCH_API_PROFESSIONAL_GENDER[professionalGender] : undefined;
}
